import _ from 'lodash';
import {LoadOptions} from 'devextreme/data';

export interface Params {
    skipCount?: number
    maxResultCount?: number
    filter?: string
    searchTerm?: string
    loadData?: any
}

function getOperator(operator: string) {
    switch (operator) {
        case '=':
            return 'equals'
        case '<>':
            return 'notEquals'
        case '>':
            return 'GreaterThan'
        case '>=':
            return 'GreaterThanOrEquals'
        case '<':
            return 'LessThan'
        case '<=':
            return 'LessThanOrEquals'
        default:
            return operator
    }
}

function mapFilter(filter: any[], mapObject: any) {
    if (typeof filter[0] === "string") {
        mapObject[filter[0]] = {
            operator: getOperator(filter[1]),
            value: filter[2]
        }
    } else {
        filter.forEach((f) => {
            if (typeof f === "string" || _.isEmpty(f)) return;
            else mapObject[f[0]] = {
                operator: getOperator(f[1]),
                value: f[2]
            }
        })
    }

}

export function getServerFilters(filters: Array<any> | undefined) {
    const mapped = {}
    if (typeof filters?.[0] === "string") {
        mapFilter(filters, mapped)
    }
     else {
        filters?.forEach(filter => {
            if (typeof filter === "string" || _.isEmpty(filter)) return;
            else filter && mapFilter(filter, mapped)
        })
    }
    return mapped;
}

export function loadFn(
    loadService: (params: Params) => Promise<{ response: any; error: any }>,
    loadData: any = {}
) {
    return async (options: LoadOptions) => {
        const filters = getServerFilters(options.filter)
        const sortValue = getSortValue(options.sort);

        const params: Params = {
            skipCount: options.skip,
            maxResultCount: options.take,
            filter:_.isEmpty(filters) ?  null : (filters as any) ,
            searchTerm: options.searchValue,
            sortingDirection: sortValue[0]?.desc ? 'DESC' : 'ASC',
            sortBy: sortValue[0]?.selector,
            ...loadData,
        }

        const {response, error} =
            typeof loadService === 'function'
                ? await loadService(params)
                : {response: null, error: 'provide get service'}

        if (error) throw error

        return {data: response.items || [], totalCount: response.totalCount ?? 0}
    }
}
export function getSortValue(sort: any) {
    if (!sort) return [];
    if (Array.isArray(sort)) return sort;
    return [{ selector: sort?.selector, desc: sort?.desc }];
}
export function handleErrors({response, error}: { response: any | null; error: object | null }) {
    if (error) {
        throw Error(JSON.stringify(error))
    }
    return response
}
